
import "devextreme/data/odata/store"
import notify from 'devextreme/ui/notify'

import { DxButton } from 'devextreme-vue'
import { DxDateBox } from 'devextreme-vue/date-box'
import { DxTextBox } from 'devextreme-vue/text-box'
import { DxSelectBox } from 'devextreme-vue/select-box'
import { DxRadioGroup } from 'devextreme-vue/radio-group'
import { DxBox, DxItem } from 'devextreme-vue/box'

import { shiftPlanService } from '../../../services/shift-plan.service'

import moment from 'moment'

const responseToChange = [
  { key: 1, value: "変更不可" },
  { key: 0, value: "変更可能" },
]

export default {
  components: {
    DxButton,
    DxDateBox,
    DxTextBox,
    DxRadioGroup,
    DxSelectBox,
    DxBox,
    DxItem,
  },
  data() {
    return {
      loading: true,
      error: false,
      success: false,
      formType: "",
      formTitle: "",
      requestMessage: "",
      currentShiftText: "",
      officeShiftChangeJobShiftText: "",
      responseToChange,
      rgResponseToChangeValue: "",
      rgResponseToChangeDisabled: false,
      workerResultId: 0,
      officeShiftChangeJobShifts: [],
      selectOfficeShiftChangeJobShiftId: "",
      slOfficeShiftChangeJobShiftDisabled: false,
      officeResponseToWorkerVisible: false,
      officeMessage: "",
      beforeShiftText: "",
      afterShiftText: "",
      btnReplyVisible: false,
      btnReplyDisabled: false,

      currentWorkerShift: {},
      currentOfficeShiftChangeJob: {},
      currentOfficeShiftChangeWorker: {},
    }
  },
  methods: {
    fetchOfficeShiftChangeJobData() {

      let self = this

      shiftPlanService.getOfficeShiftChangeJob(this.$route.params.workingDay)
        .then(success => {
          if (success.messageType == 1) {

            self.currentOfficeShiftChangeJob = success.content
            self.currentOfficeShiftChangeWorker = success.content.officeShiftChangeWorkers[0]
            self.currentWorkerShift = self.currentOfficeShiftChangeJob.workerShift

            if (self.isOutTimeOfficeShiftChangeJob(self.currentWorkerShift)) {

              self.showMessage(process.env.VUE_APP_BASE_MESSAGE_ROWVISION_WRONG, 'error');

              this.$store.commit(
                {
                  type: 'setShiftAdjustAllWorkerShiftsByWorkerShift',
                  workerShift: self.currentWorkerShift
                })

              self.onClickToBackShiftAdjust(null, self)

              return
            }

            self.initFormInfo(self)

            if (self.formType == "confirm") {
              self.confirmOfficeShiftChangeJob(self)
            }
          } else {
            if(success.messageCode == "W00004"){
              self.showMessage(process.env.VUE_APP_BASE_MESSAGE_ROWVISION_WRONG, 'error');
            }else{
              self.showMessage(success.message, 'error');
            }

            self.onClickToBackShiftAdjust(null, self)
          }

          self.loading = false
          self.error = false
          self.success = true

          self.loadPanelVisible = false
        }).catch((errors) => {
          console.log(errors)

          self.loadPanelVisible = false
        })
    },
    confirmOfficeShiftChangeJob(self) {

      self.currentOfficeShiftChangeWorker.treatStatusId = 4
      self.currentOfficeShiftChangeWorker._State_ = 4

      self.currentWorkerShift.changeStatusId = 0
      self.currentWorkerShift._State_ = 4

      shiftPlanService.confirmOfficeShiftChangeJob(self.currentWorkerShift, self.currentOfficeShiftChangeWorker)
        .then(
          success => {
            if (success.messageType == 0) this.showMessage(success.message, 'error');
          },
          error => {
            console.log(error)
          }
        )
    },
    initFormInfo(self) {

      //タイトル、ボタン編集 formType formTitle btnReplyDisabled
      if (self.currentOfficeShiftChangeWorker.treatStatusId == 1) {
        self.formType = "reply"
        self.formTitle = "事務所要請への回答"
        self.btnReplyDisabled = false
        self.btnReplyVisible = true
      }
      if (self.currentOfficeShiftChangeWorker.treatStatusId == 3) {
        self.formType = "confirm"
        self.formTitle = "事務所要請の確認"
        self.btnReplyDisabled = true
        self.btnReplyVisible = false
      }
      //メッセージ編集 requestMessage
      self.requestMessage = self.currentOfficeShiftChangeJob.requestMessage

      //現在シフト currentShiftText
      if (self.currentWorkerShift.shiftId != null) {
        self.currentShiftText =
          self.currentWorkerShift.shiftCode + ":" + self.currentWorkerShift.displayShiftTimeText
      } else {
        self.currentShiftText = "休"
      }

      //お願いしたいシフト officeShiftChangeJobShiftText
      if (self.currentOfficeShiftChangeJob.changeTypeId == 1 || self.currentOfficeShiftChangeJob.changeTypeId == 3) {
        let _officeShiftChangeJobShiftCodes = []
        for (let _officeShiftChangeJobShift of self.currentOfficeShiftChangeJob.officeShiftChangeShifts) {

          let shiftData = _officeShiftChangeJobShift.shiftText.split(":")
          _officeShiftChangeJobShiftCodes.push(shiftData[0])
        }
        self.officeShiftChangeJobShiftText = _officeShiftChangeJobShiftCodes.join(",")
      }
      if (self.currentOfficeShiftChangeJob.changeTypeId == 2) {

        self.officeShiftChangeJobShiftText = "休"
      }

      //ボタン編集 rgResponseToChangeDisabled
      self.rgResponseToChangeDisabled = self.currentOfficeShiftChangeWorker.treatStatusId == 1 ? false : true

      //slOfficeShiftChangeJobShiftDisabled
      self.slOfficeShiftChangeJobShiftDisabled = self.currentOfficeShiftChangeWorker.treatStatusId == 1 ? false : true

      //officeShiftChangeJobShifts
      if (self.currentOfficeShiftChangeJob.changeTypeId == 1 || self.currentOfficeShiftChangeJob.changeTypeId == 3) {

        for (let _officeShiftChangeJobShift of self.currentOfficeShiftChangeJob.officeShiftChangeShifts) {
          self.officeShiftChangeJobShifts.push({
            "shiftId": _officeShiftChangeJobShift.shiftId,
            "shiftText": _officeShiftChangeJobShift.shiftText
          })
        }
      }
      if (self.currentOfficeShiftChangeJob.changeTypeId == 2) {

        self.officeShiftChangeJobShifts.push({
          "shiftId": 0,
          "shiftText": "休"
        })
      }

      //this.rgResponseToChangeValue
      if (self.currentOfficeShiftChangeWorker.workerResultId == null) {
        self.rgResponseToChangeValue = self.responseToChange[1]
      } else {
        self.rgResponseToChangeValue = self.currentOfficeShiftChangeWorker.workerResultId == 0 ? self.responseToChange[0] : self.responseToChange[1]
      }

      //選択シフト selectOfficeShiftChangeJobShiftId
      if (self.currentOfficeShiftChangeWorker.workerResultId == null) {

        self.selectOfficeShiftChangeJobShiftId = self.officeShiftChangeJobShifts[0].shiftId
      } else {
        self.selectOfficeShiftChangeJobShiftId =
          self.currentOfficeShiftChangeWorker.workerResultId == 0
            ? null
            : (self.currentOfficeShiftChangeWorker.afterShiftId == null ? 0 : self.currentOfficeShiftChangeWorker.afterShiftId)
      }

      //officeResponseToWorkerVisible
      self.officeResponseToWorkerVisible = self.currentOfficeShiftChangeWorker.treatStatusId == 1 ? false : true

      if (self.officeResponseToWorkerVisible) {

        //officeMessage
        self.officeMessage =
          (self.currentOfficeShiftChangeWorker.officeResultId == 1 ? "OK" : "NG")
          + (self.currentOfficeShiftChangeWorker.officeMessage == null ? "" : (":" + self.currentOfficeShiftChangeWorker.officeMessage))

        //beforeShiftText
        if (self.currentOfficeShiftChangeWorker.beforeShiftId != null) {
          self.beforeShiftText = self.currentOfficeShiftChangeWorker.beforeShiftText
        } else {
          self.beforeShiftText = "休"
        }

        //afterShiftText
        //事務所回答OKの場合、変更後のシフトを表示する
        if(self.currentOfficeShiftChangeWorker.officeResultId == 1){
          if (self.currentOfficeShiftChangeWorker.afterShiftId != null) {
            self.afterShiftText = self.currentOfficeShiftChangeWorker.afterShiftText
          } else {
            self.afterShiftText = "休";
          }
        }else{ //事務所回答NGの場合、変更前のシフトを表示する
          self.afterShiftText = self.beforeShiftText;
        }
        
      }
    },
    onValueChangedResponseToChange(e) {

      if (!this.rgResponseToChangeDisabled) {
        if (e.value.key == 0) {

          this.slOfficeShiftChangeJobShiftDisabled = false
        } else {

          this.slOfficeShiftChangeJobShiftDisabled = true
          this.selectOfficeShiftChangeJobShiftId = null
        }
      }

    },
    onClickToReplyChange() {
      if (this.rgResponseToChangeValue == this.responseToChange[1]
        && this.selectOfficeShiftChangeJobShiftId == null) {
        this.showMessage(process.env.VUE_APP_BASE_MESSAGE_SELECT_SHIFT, 'error')
        return
      }
      if (this.rgResponseToChangeValue == this.responseToChange[1]
        && (this.selectOfficeShiftChangeJobShiftId == this.currentWorkerShift.shiftId || (this.selectOfficeShiftChangeJobShiftId == 0 && this.currentWorkerShift.shiftId == null))) {

        this.showMessage(process.env.VUE_APP_BASE_MESSAGE_SAME_SHIFT, 'error')
        return
      }

      this.currentOfficeShiftChangeWorker.workerProxyFlag = 0
      this.currentOfficeShiftChangeWorker._State_ = 4

      if (this.rgResponseToChangeValue == this.responseToChange[0]) {

        this.currentOfficeShiftChangeWorker.workerResultId = 0
        this.currentOfficeShiftChangeWorker.afterShiftId = null
        this.currentOfficeShiftChangeWorker.afterLaborHour = null
        this.currentOfficeShiftChangeWorker.officeResultId = 1
        this.currentOfficeShiftChangeWorker.treatStatusId = 4

        this.currentWorkerShift.changeStatusId = 0
        this.currentWorkerShift._State_ = 4
      } else {

        this.currentOfficeShiftChangeWorker.workerResultId = 1
        this.currentOfficeShiftChangeWorker.afterShiftId = this.selectOfficeShiftChangeJobShiftId > 0 ? this.selectOfficeShiftChangeJobShiftId : null
        if (this.currentOfficeShiftChangeWorker.afterShiftId != null) {

          for (let shift of this.currentOfficeShiftChangeJob.officeShiftChangeShifts) {

            if (shift.shiftId == this.currentOfficeShiftChangeWorker.afterShiftId) {

              this.currentOfficeShiftChangeWorker.afterLaborHour = shift.laborHour
              break
            }
          }
        }

        if (this.currentOfficeShiftChangeJob.autoApprovalFlag == 1) {
          this.currentOfficeShiftChangeWorker.officeResultId = 1
          this.currentOfficeShiftChangeWorker.officeMessage = this.$store.state.constantShiftChangeAutoMsg
          this.currentOfficeShiftChangeWorker.treatStatusId = 3

          if (this.currentWorkerShift.workContentId == null) {
            this.currentWorkerShift.workContentId = this.$store.state.worker.defaultWorkContentId
          }
          this.currentWorkerShift.shiftId = this.currentOfficeShiftChangeWorker.afterShiftId
          this.currentWorkerShift.absenceType = null
          this.currentWorkerShift._State_ = 4
          this.currentWorkerShift.changeType = 2
        } else {
          this.currentOfficeShiftChangeWorker.officeResultId = null
          this.currentOfficeShiftChangeWorker.treatStatusId = 2
        }
      }

      let self = this

      shiftPlanService.replyOfficeShiftChangeJob(this.currentWorkerShift, this.currentOfficeShiftChangeWorker)
        .then(
          success => {

            if (success.messageType == 1) {

              self.showMessage(success.message, 'success');
              setTimeout(self.onClickToBackShiftAdjust(null, self), 1000, self)

              self.btnReplyDisabled = true
              self.rgResponseToChangeDisabled = true
              self.slOfficeShiftChangeJobShiftDisabled = true
            } else {
              self.showMessage(success.message, 'error');
            }
          },
          error => {
            console.log(error)
          }
        )
    },
    isOutTimeOfficeShiftChangeJob(workerShift) {
      let year = moment(new Date(workerShift.workingDay)).year()
      let month = moment(workerShift.workingDay).month()

      for (let _monthlyWorkerShifts of this.$store.state.shiftAdjustAllWorkerShifts) {
        let _yearMonth = moment(new Date(_monthlyWorkerShifts.yearMonth))
        let _year = _yearMonth.year()
        let _month = _yearMonth.month()
        if (year == _year && month == _month) {
          for (let _workerShift of _monthlyWorkerShifts.workerShifts) {
            if (moment(new Date(workerShift.workingDay)).diff(moment(new Date(_workerShift.workingDay)), 'days') == 0) {
              console.log(workerShift)
              console.log(_workerShift)
              if (workerShift.rowVersion != _workerShift.rowVersion || 
                workerShift.officeShiftChangeId != _workerShift.officeShiftChangeId ||
                workerShift.officeShiftChangeTreatStatusId != _workerShift.officeShiftChangeTreatStatusId) {
                  
                return true
              } else {
                return false
              }
            }
          }
        }
      }
      return false
    },
    onClickToBackShiftAdjust(e, self) {
      if (e != null) self = this

      shiftPlanService.getWorkerShifts(
        moment(this.$route.params.workingDay).format("YYYY-MM-DD")
        , moment(this.$route.params.workingDay).format("YYYY-MM-DD"))
        .then(success => {
          if (success.messageType == 1) {
            self.$store.commit(
              {
                type: 'setShiftAdjustAllWorkerShiftsByWorkerShift',
                workerShift: success.content[0].workerShifts[0]
              })

            if (self.$store.state.fromUrlName != null && self.$store.state.fromUrlName != "") {
              self.$router.push({ name: self.$store.state.fromUrlName })
            } else {
              self.$router.push({ name: 'shift-adjustment' })
            }
          } else {
            self.showMessage(success.message, 'error');
          }
        }).catch((errors) => {
          console.log(errors)
        })
    },
    showMessage(text, type) {
      notify({ message: text, shading: true }, type, process.env.VUE_APP_BASE_MESSAGE_NOTIFY_SHOWTIME)
    },
  },
  mounted() {
    this.fetchOfficeShiftChangeJobData()
  },
  watch: {
    '$route': 'fetchOfficeShiftChangeJobData'
  },
}